import {
  ClickArgs,
  DBLClickArgs,
  MouseDownArgs,
  MouseMoveArgs,
  MouseToolEvents,
  MouseUpArgs,
} from 'editor/systems/addSheetEvents/sheetEventHandlers';
import cursorEvents from './cursorEvents';
import linkSelectionEvents from './linkSelectionEvents';
import moveControlPointEvents from './moveControlPointEvents';
import moveMarkupEvents from './moveMarkupEvents';
import selectMarkupEvents from './selectMarkupEvents';
import updateTextEvents from './updateTextEvents';

function mouseDown(args: MouseDownArgs): void {
  moveControlPointEvents.mouseDown(args);
  cursorEvents.mouseDown(args);
  moveMarkupEvents.mouseDown(args);
}

function mouseMove(args: MouseMoveArgs): void {
  cursorEvents.mouseMove(args);
  moveMarkupEvents.mouseMove(args);
  moveControlPointEvents.mouseMove(args);
  linkSelectionEvents.mouseMove(args);
}

function mouseUp(args: MouseUpArgs): void {
  linkSelectionEvents.mouseUp(args);
  cursorEvents.mouseUp(args);
  moveControlPointEvents.mouseUp(args);
  moveMarkupEvents.mouseUp(args);
}

function click(args: ClickArgs): void {
  selectMarkupEvents.click(args);
}

function dblclick(args: DBLClickArgs): void {
  updateTextEvents.dblclick(args);
}

const pointerEvents: MouseToolEvents = {
  mouseDown,
  mouseMove,
  mouseUp,
  click,
  dblclick,
};

export default pointerEvents;
